<div (window:resize)="onResize($event)">
    <ng-container *ngIf="!showPage">
        <div class="loading text-center">
            <br />
            <img style="padding-top:50px;" src="../../../assets/img/gif/loading.gif" alt="Alternate Text" />
            <br />
            <p>Loading questions, please wait...</p>
        </div>
    </ng-container>


    <ng-container *ngIf="showPage">

        <div>
            <div class="row">
                <div class="container-fluid">
                    <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                        <h1 class="h3 mb-0 text-gray-800"></h1>
                        <div class="btns-container">
                            <div>
                                <a (click)="deleteSelected()" class="d-none d-sm-inline-block btn btn-sm shadow-sm" [ngClass]="{'btn-red': canDelete, 'btn-gray': !canDelete}">
                                    <i class="fas fa-trash text-white-50"> <span class="button-text"> Delete</span></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <!--<div class="col-sm-9 table-actions">
         <div (click)="editSelected()" [ngClass]="{'icon_disabled': canEdit == false}">
            <i class="material-icons" [ngClass]="{'icon_disabled': canEdit == false}">edit</i>
            <span>Edit</span>
        </div>

        <div (click)="deleteSelected()" [ngClass]="{'icon_disabled': canDelete == false}">
            <i class="material-icons" [ngClass]="{'icon_disabled': canDelete == false}">delete</i>
            <span>Delete</span>
        </div>
    </div>-->

                <div class="col-sm-3 text-right table-actions-buttons topSpacingBtn">
                    <!--<button (click)="openModal('create')" type="button" class="btn btn-warning">
            Create
        </button>-->
                    <a (click)="openModal('create')" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                        <i class="fas fa-plus text-white-50"> <span class="button-text">Create Question</span></i>
                    </a>
                </div>
            </div>
        </div>

        <div>
            <div style="width: 100%; max-height: 400px; height:400px;">
                <ag-grid-angular #agGrid
                                 style="width: 100%; height: 100%;"
                                 class="ag-theme-balham"
                                 [enableFilter]="true"
                                 [floatingFilter]="true"
                                 [gridOptions]="gridOptions"
                                 [rowData]="questions"
                                 [columnDefs]="questionsHeaders"
                                 [enableSorting]="true"
                                 [enableColResize]="true"
                                 (rowClicked)="onRowClicked($event)"
                                 (gridReady)="onGridReady($event)"
                                 [pagination]="true"
                                 [paginationPageSize]="25"
                                 [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                 [rowSelection]="rowSelection"
                                 (rowSelected)="onRowSelected($event)"
                                 (selectionChanged)="onSelectionChanged($event)"
                                 [rowMultiSelectWithClick]="true"
                                 [suppressRowClickSelection]="true">
                </ag-grid-angular>
            </div>
        </div>
    </ng-container>
</div>
<app-new-survey-modal #newsurvey></app-new-survey-modal>
